import React from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@vio/atlas/helpers/Flex';
import { Text } from '@vio/atlas/Text';
import { Toggle } from '@vio/atlas/Toggle';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
const _exp = /*#__PURE__*/() => Flex.Row;
const Wrapper = /*#__PURE__*/styled(_exp())({
  name: "Wrapper",
  class: "w10d60kj",
  propsAsIs: true
});
const _exp8 = /*#__PURE__*/() => Text;
const Subtitle = /*#__PURE__*/styled(_exp8())({
  name: "Subtitle",
  class: "st89rs8",
  propsAsIs: true
});
interface Props {
  checked: boolean;
  onChange: () => void;
  // Added for 0715b2bb-hack-skeletons
  toggleMessage?: React.ReactNode;
  totalPriceMessage: React.ReactNode;
}
export const TotalPriceToggleMobile: React.FC<Props> = ({
  checked,
  onChange,
  toggleMessage,
  totalPriceMessage
}) => {
  return <Wrapper gap="s400" justifyContent="space-between">
      <div>
        <Text variant="labelS">
          {toggleMessage || <FormattedMessageWrapper id="showTotalPrice" defaultMessage="Show total price" />}
        </Text>
        <Subtitle variant="bodyXS">{totalPriceMessage}</Subtitle>
      </div>
      <Toggle id="TotalPriceToggle" checked={checked} onChange={onChange} />
    </Wrapper>;
};

require("./TotalPriceToggleMobile.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./TotalPriceToggleMobile.tsx");